import { Sparkles } from 'lucide-react';
import type { CSSProperties } from 'react';
import { cn } from '../lib/cn';

const SIZES = {
  24: 'size-6 text-avatar',
  32: 'size-8 text-caption',
  40: 'size-10 text-body-s',
} as const;

/**
 * Avatar z inicjałami (Figma: Avatar 3004:291). Kolor osoby to dane (`users.avatar_color`):
 * tło = 10% koloru, tekst = kolor. Bez koloru: akcent. Wariant `ai` = tło akcentu.
 */
export function Avatar({
  initials,
  color,
  size = 24,
  ai = false,
  title,
  className,
}: {
  initials?: string;
  color?: string | null;
  size?: keyof typeof SIZES;
  ai?: boolean;
  title?: string;
  className?: string;
}) {
  if (ai) {
    return (
      <span
        role="img"
        aria-label={title ?? 'AI'}
        className={cn(
          'inline-flex shrink-0 items-center justify-center rounded-full bg-accent text-on-accent',
          SIZES[size],
          className,
        )}
      >
        <Sparkles size={size === 24 ? 12 : 16} strokeWidth={1.75} aria-hidden />
      </span>
    );
  }
  const style = color ? ({ '--avatar': color } as CSSProperties) : undefined;
  return (
    <span
      role="img"
      aria-label={title ?? initials}
      style={style}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold uppercase select-none',
        color
          ? 'bg-[color-mix(in_srgb,var(--avatar)_10%,transparent)] text-[var(--avatar)]'
          : 'bg-accent-subtle text-accent',
        SIZES[size],
        className,
      )}
    >
      {(initials ?? '').slice(0, 2)}
    </span>
  );
}
